import type { EventBusPayload } from "@/modules/event-bus";

import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { isNotificationBroadcastProjectAssignPayload } from "@/entities/notification-broadcast";
import { useInvalidateNotificationsDatabase } from "@/entities/notifications-database";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";

import { notifyProjectAssign } from "./project-action-assign.helper";

export const useProjectActionAssign = () => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const queryClient = useQueryClient();
  const { invalidateNotifications } = useInvalidateNotificationsDatabase();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isNotificationBroadcastProjectAssignPayload(payload)) return;
    if (isBroadcastNotificationEnabled("project-assign")) {
      const title = t("notification:projectAssign.description", {
        userName: payload.user.name,
        projectName: payload.projects[0]?.name ?? "",
        count: payload.projects.length,
      });
      notifyProjectAssign({ title, notify, payload });
    }
    queryClient.invalidateQueries({
      queryKey: ["projects"],
    });
    invalidateNotifications("*");
  };

  return { runAction };
};
